import React from "react";
import NavPublicUser from "../navbarPublicUser";
import Footer from "../Footer";
import PubDetails from "../PubDetails";
import PubChangePassword from "../PubChangePassword";
import PubRemove from "../PubRemove";
export default function PubProfile() {
    return (
        <div>
            <NavPublicUser />
           <PubDetails/>
           <PubChangePassword/>
           <PubRemove/>
            <Footer />
        </div>
    );
}

